import { Badge } from 'braid-design-system';

/**
 * Badge indicating that some guidance is still early and directional.
 */
export const Note = () => (
  <Badge tone="promote" weight="strong">
    Note
  </Badge>
);
